<template>
    <div class="auth-details fff">
        <div class="auth-management-top mb20">
            <!-- <h1 class="font-normal mb10">角色名称：{{ roleName }}</h1> -->
            <div>
                <span class="cur" @click="backDetails"><i class="el-icon-arrow-left"></i>返回</span>
                <el-divider direction="vertical" class="color999"></el-divider>
                <span class="color999 cur" @click="back">角色权限管理&nbsp;/&nbsp;</span>
                <span class="color999 cur">新增角色&nbsp;&nbsp;</span>
            </div>
        </div>
        <!-- 权限详情 -->
        <div style="width: 600px;display: flex;align-items: center;" class="mb20">
            <div><span style="display: inline-block;">角色名称：</span><el-input size="small" placeholder="请输入角色名称"
                    v-model="roleName" style="width: 200px;" maxlength="8" /></div>
            <div class="ml20">
                <el-button type="default" size="small" @click="cancel('1')">取消</el-button>
                <el-button type="primary" size="small" class="resetbgc" @click="save('1')">保存</el-button>
            </div>
        </div>
        <div class="auth-detail">
            <div class="nav-top">
                <div class="item">序号</div>
                <div class="item">模块</div>
                <div class="item">功能</div>
                <div class="item">授权</div>
                <div class="item">全选</div>
            </div>
            <div class="content" style="max-height: 650px;overflow-y: auto;">
                <div v-for="item, index in menuList" :key="index" style="border-bottom: 1px solid #000;display: flex;"
                    class="">
                    <div style="margin-right: 200px;min-width: 100px!important;display: flex;align-items: center;">{{ index
                        + 1
                    }}</div>
                    <div style="margin-right: 200px;min-width: 100px;display: flex;align-items: center;">{{ item.name }}
                    </div>
                    <div>
                        <div v-for="i, d in item.nextMenuList" :key="d"
                            style="display: flex;margin-bottom: 20px;align-items: center;">
                            <div style="min-width: 100px;margin-right: 200px;display: flex;">{{ i.name }}</div>
                            <div style="display: flex;min-width: 300px;flex-wrap: wrap;flex-direction: column;">
                                <div v-for="c, z in i.nextMenuList" :key="z" style="margin-bottom: 10px;margin-right: 5px;">
                                    <template v-if="!(c.dataPermList.length > 0)">
                                        <el-checkbox v-model="c.selectFlag" :disabled="systemTag == 'yes'"
                                            @change="changeCheckbox($event, c, i)"></el-checkbox> {{ c.name }}</template>
                                    <template v-else>
                                        <el-checkbox v-model="c.selectFlag" @change="doCheck($event, c, i)"></el-checkbox>
                                        {{
                                            c.name }}
                                        <div v-if="c.selectFlag"
                                            style="background: rgb(242, 242, 242);padding-top: 10px;max-width:200px ;">
                                            <el-radio-group v-for="radio, radioIndex in c.dataPermList" :key="radioIndex"
                                                v-model="radio[0].showId" @change="changeRadio($event, radio)"
                                                style="margin-bottom: 5px;">
                                                <el-radio :label="it.id" v-for="it, itIndex in radio" :key="itIndex">{{
                                                    it.name }}</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div style="min-width: 100px;display: flex;">
                                <el-switch v-model="i.selectFlag" active-color="#13ce66" inactive-color="#DCDCDC"
                                    @change="allChoose($event, i)">
                                </el-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menuList: [],
            roleName: '',
            appList: [],
            menuIdList: [], // 权限(菜单ID)数组
            dataPermIdList: [], // 数据权限(菜单ID)数组
            chooseList: [],
            systemTag: '',
            id: ''
        }
    },
    created() {
        this.init()
        // this.getAppList()
    },

    methods: {
        allChoose(flag, row) {
            if (flag) {
                row.nextMenuList.map(item => {
                    if (!(this.menuIdList.includes(item.id))) {
                        this.menuIdList.push(item.id)
                    }
                    if (item.dataPermList.length > 0) {
                        item.dataPermList.map(data => {
                            data[0].showId = data[0].id
                            data[0].oldShowId = data[0].showId
                            if (!(this.dataPermIdList.includes(data[0].showId))) {
                                this.dataPermIdList.push(data[0].showId)
                            }
                        })
                    }
                    item.selectFlag = true
                })
            } else {
                row.nextMenuList.map(item => {
                    let index = this.menuIdList.indexOf(item.id)
                    this.menuIdList.splice(index, 1)
                    item.selectFlag = false

                    if (item.dataPermList.length > 0) {
                        item.dataPermList.map(data => {
                            let index = this.dataPermIdList.indexOf(data.id)
                            this.dataPermIdList.splice(index, 1)
                        })
                    }
                })
            }
        },
        changeCheckbox(flag, button, item) {
            let length = item.nextMenuList.length
            if (flag && !(this.menuIdList.includes(button.id))) {
                this.menuIdList.push(button.id)
                item.isCount++
                item.selectFlag = length === item.isCount
            } else {
                let index = this.menuIdList.indexOf(button.id)
                this.menuIdList.splice(index, 1)
                item.isCount--
                item.selectFlag = length === item.isCount
            }
        },
        async init() {
            const res = await this.$api.post(this.$url.auth.edtiList, { roleId: '' })
            this.roleName = res.roleName
            this.menuList = res.menuVOList
            res.menuVOList.map(v => {
                v.nextMenuList.map(h => {
                    h.nextMenuList.map(j => {
                        this.$set(h, 'isCount', 0)
                        this.$set(h, 'seleArr', [])
                        if (j.selectFlag) {
                            this.menuIdList.push(j.id)
                            h.seleArr.push(j.selectFlag)
                            h.isCount = h.seleArr.length
                        }
                        if (j.dataPermList.length > 0) {
                            j.dataPermList.map(data => {
                                data.forEach((dataItem, dataIndex) => {
                                    if (dataItem.showId != '') {
                                        this.dataPermIdList.push(dataItem.id)
                                    }
                                })
                            })
                        }
                    })
                })
            })
        },
        cancel(option) {
            if (option == '1') {
                this.$router.push({
                    path: '/dataList/authManagement'
                })
            }
        },
        async save(option) {
            if (option == '1') {
                const res = await this.$api.post(this.$url.auth.saveAuth,
                    {
                        roleName: this.roleName,
                        menuIdList: this.menuIdList,
                        dataPermIdList: this.dataPermIdList
                    })
                if (res) {
                    this.$message.success('保存成功')
                    this.$router.push({
                        path: '/dataList/authManagement',
                    })
                }
            }
        },
        //选择某一个单元
        doCheck(flag, button, item) {
            let length = item.nextMenuList.length
            if (flag) {
                item.isCount++
                item.selectFlag = length === item.isCount
                console.log(item.selectFlag);
                if (!(this.menuIdList.includes(button.id))) {
                    this.menuIdList.push(button.id)
                }
                button.dataPermList.map(item => {
                    item[0].showId = item[0].id
                    item[0].oldShowId = item[0].showId
                    if (!(this.dataPermIdList.includes(item[0].showId))) {
                        this.dataPermIdList.push(item[0].showId)
                    }
                })
            } else {
                item.isCount--
                item.selectFlag = length === item.isCount
                let index = this.menuIdList.indexOf(button.id)
                this.menuIdList.splice(index, 1)
                button.dataPermList.map(item => {
                    let index = this.dataPermIdList.indexOf(item[0].showId)
                    if (index != -1) this.dataPermIdList.splice(index, 1)
                    item[0].showId = ''
                })
            }
        },
        changeRadio(val, radio) {
            let index = this.dataPermIdList.indexOf(radio[0].oldShowId)
            if (index != -1) this.dataPermIdList.splice(index, 1)
            if (!(this.dataPermIdList.includes(val))) this.dataPermIdList.push(val)
            radio[0].oldShowId = val
        },
        selectChange(val) {
            this.chooseList = val
        },
        backDetails() {
            this.$router.push({
                path: '/dataList/authManagement'
            });
        },
        back() {
            this.$router.push("/dataList/authManagement");
        }
    }
}
</script>

<style scoped lang="less">
.auth-details {
    padding: 25px;
}

.el-button.resetbgc {
    background: rgb(32, 107, 248)
}

.auth-list {
    display: flex;
    flex-wrap: wrap;
}

.nav-top {
    display: flex;
    align-items: center;
    height: 50px;
    background-color: rgb(242, 242, 242);

    .item {
        min-width: 100px;
        margin-right: 200px;
    }
}

.btn-group {
    display: flex;
    align-items: center;
    // height: 50px;
    justify-content: flex-end;
}
</style>